/**
 * Instagram's official reel embed (decision 81). Since videos aren't saved by default, this is the reel player in the
 * inspector and on public share pages: cross-origin, sandboxed (IG_EMBED_SANDBOX), lazy-loaded, no referrer (rule 9).
 * The app's CSP allows https://www.instagram.com in frame-src (apps/app/csp.ts).
 */
import { IG_EMBED_SANDBOX, igEmbedUrl } from '../format';

export function InstagramEmbed({ shortcode, title = 'Instagram reel', className, onLoad }: { shortcode: string; title?: string; className?: string; onLoad?: () => void }) {
  return (
    <iframe title={title} src={igEmbedUrl(shortcode)} referrerPolicy="no-referrer" sandbox={IG_EMBED_SANDBOX} loading="lazy"
      allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowFullScreen scrolling="no" className={className} onLoad={onLoad} />
  );
}
